"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandTriggerInput = exports.DemandTriggerUpdate = exports.DemandTriggerCreate = exports.DemandTriggerSummary = exports.TriggerPayload = void 0;
const zod_1 = require("zod");
const enums_js_1 = require("./enums.js");
// Mutually-exclusive (player_id XOR group_id): exactly one must be non-null.
// Mirrors the DB CHECK ((player_id IS NULL) <> (group_id IS NULL)).
function applyTargetXor(value, ctx) {
    const hasPlayer = value.player_id != null;
    const hasGroup = value.group_id != null;
    if (hasPlayer === hasGroup) {
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            message: 'Exactly one of player_id or group_id must be set (mutually exclusive, both required-or-not)',
            path: ['player_id'],
        });
    }
}
exports.TriggerPayload = zod_1.z.record(zod_1.z.unknown());
exports.DemandTriggerSummary = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    tenant_id: zod_1.z.string().uuid(),
    player_id: zod_1.z.string().uuid().nullable(),
    group_id: zod_1.z.string().uuid().nullable(),
    composer_id: zod_1.z.string().uuid(),
    trigger_type: zod_1.z.enum(enums_js_1.TriggerTypes),
    trigger_payload: exports.TriggerPayload,
    active_from: zod_1.z.string().datetime(),
    active_until: zod_1.z.string().datetime().nullable(),
    cooldown_seconds: zod_1.z.number().int().nonnegative(),
    max_fires_per_day: zod_1.z.number().int().positive().nullable(),
    last_fired_at: zod_1.z.string().datetime().nullable(),
    created_by_id: zod_1.z.string().uuid(),
    created_at: zod_1.z.string().datetime(),
});
exports.DemandTriggerCreate = zod_1.z
    .object({
    player_id: zod_1.z.string().uuid().nullable(),
    group_id: zod_1.z.string().uuid().nullable(),
    composer_id: zod_1.z.string().uuid(),
    trigger_type: zod_1.z.enum(enums_js_1.TriggerTypes),
    trigger_payload: exports.TriggerPayload.default({}),
    active_from: zod_1.z.string().datetime().optional(),
    active_until: zod_1.z.string().datetime().nullable().default(null),
    cooldown_seconds: zod_1.z.number().int().nonnegative().default(0),
    max_fires_per_day: zod_1.z.number().int().positive().nullable().default(null),
})
    .superRefine(applyTargetXor);
exports.DemandTriggerUpdate = zod_1.z
    .object({
    player_id: zod_1.z.string().uuid().nullable(),
    group_id: zod_1.z.string().uuid().nullable(),
    trigger_type: zod_1.z.enum(enums_js_1.TriggerTypes).optional(),
    trigger_payload: exports.TriggerPayload.optional(),
    active_from: zod_1.z.string().datetime().optional(),
    active_until: zod_1.z.string().datetime().nullable().optional(),
    cooldown_seconds: zod_1.z.number().int().nonnegative().optional(),
    max_fires_per_day: zod_1.z.number().int().positive().nullable().optional(),
})
    .superRefine(applyTargetXor);
// Player runtime → server: reports that a player observed a trigger firing
// (touch corner gesture, inductor pulse, network relay, etc.) that should
// fire its bound demand composer. The server resolves the corresponding
// DemandTrigger row, applies cooldown, and emits command.issued.
exports.DemandTriggerInput = zod_1.z.object({
    trigger_type: zod_1.z.enum(enums_js_1.TriggerTypes),
    trigger_payload: exports.TriggerPayload.default({}),
    fired_at: zod_1.z.string().datetime(),
});
//# sourceMappingURL=demand.schema.js.map